// extracted by mini-css-extract-plugin
module.exports = {"forgetPasswordBlock":"ForgetPassword_forgetPasswordBlock__jMI5w","forgetPasswordBlock__logo":"ForgetPassword_forgetPasswordBlock__logo__24rza","spin":"ForgetPassword_spin__3N5EW"};